import React, { useState } from "react";
import CompanyAvatar from "./CompanyAvatar";

const Tabs = ({
  title,
  tabs,
  supplier,
  onTabChange,
  handleGoBack,
  management,
  engagementTabs,
  isEngagementTab,
  setEngagementTab,
  setSelectedEngagementTab,
  selectedEngagementTab,
  mngmtSelectedTab,
}) => {
  const [selectedTab, setSelectedTab] = useState(mngmtSelectedTab || tabs[0]);
  const handleTabClick = (tab) => {
    if (tab === "Supplier engagement") setEngagementTab(true);
    else if (tab === "Supplier profile") setEngagementTab(false);

    setSelectedTab(tab);
    if (onTabChange) {
      onTabChange(tab);
    }
  };

  const handleEngagementTabClick = (tab) => {
    setSelectedEngagementTab(tab);
  };

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-[#1D2739] font-bold text-[24px] font-['Hanken_Grotesk'] text-left">
        {title}
      </h2>
      {management && (
        <div className="flex justify-start items-center mb-8 mt-10 gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="10"
            viewBox="0 0 16 10"
            fill="none"
          >
            <path
              d="M2.12657 5.65501L5.19217 8.88645C5.3173 9.01834 5.37736 9.17222 5.37236 9.34808C5.36735 9.52394 5.30208 9.67782 5.17653 9.80972C5.05141 9.93062 4.90542 9.99393 4.73859 9.99965C4.57175 10.0054 4.42577 9.94205 4.30064 9.80972L0.171462 5.45717C0.108899 5.39122 0.0644787 5.31978 0.0382021 5.24284C0.0119255 5.1659 -0.000795678 5.08347 3.85008e-05 4.99554C3.85008e-05 4.90761 0.0131766 4.82517 0.0394533 4.74823C0.0657299 4.67129 0.109733 4.59985 0.171462 4.5339L4.30064 0.181356C4.41534 0.0604518 4.55882 0 4.73108 0C4.90334 0 5.05182 0.0604518 5.17653 0.181356C5.30166 0.313251 5.36422 0.469987 5.36422 0.651563C5.36422 0.833139 5.30166 0.989655 5.17653 1.12111L2.12657 4.33606H15.3744C15.5516 4.33606 15.7003 4.39937 15.8204 4.52599C15.9406 4.65261 16.0004 4.80912 16 4.99554C16 5.18239 15.9399 5.33912 15.8198 5.46574C15.6997 5.59236 15.5512 5.65545 15.3744 5.65501H2.12657Z"
              fill="#7B7B7B"
            />
          </svg>
          <span
            onClick={handleGoBack}
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "#9A9A9A",
            }}
          >
            Go back
          </span>
        </div>
      )}
      {supplier && selectedTab !== "Supplier profile" && (
        <div className="flex items-center space-x-4 mb-8">
          <div>
            <CompanyAvatar companyName={supplier?.company?.name} size="106px" />
          </div>

          <div className="flex flex-col justify-center space-y-1 text-left">
            <span className="text-[24px] font-semibold text-[#1D2739] font-hanken">
              {supplier?.company?.name}
            </span>

            <span className="text-[20px] text-[#9A9A9A] font-hanken font-normal">
              {supplier?.industry?.name}
            </span>

            <div className="flex flex-col space-y-1 text-[#9A9A9A] font-hanken text-[16px]">
              <p>
                {(() => {
                  const location = supplier?.address?.type?.[0];
                  if (!location) return null;

                  const parts = [
                    location.city,
                    location.state,
                    location.country,
                  ].filter(Boolean);

                  if (parts.length === 0) return null;

                  return <p>{parts.join(", ")}</p>;
                })()}
              </p>
              <div className="flex items-center space-x-2 text-sm">
                <p>Rating:</p>
                <span className="supplier-rating">
                  <p>{4.9}</p>
                </span>

                {supplier?.diversity?.certificationType.length > 0 && (
                  <span className="flex items-center space-x-1 ml-4">
                    <svg
                      className="w-4 h-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <g clipPath="url(#clip0)">
                        <mask
                          id="mask0"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="16"
                          height="16"
                        >
                          <path
                            d="M8.00066 14.6663C8.87629 14.6674 9.74351 14.4955 10.5525 14.1604C11.3615 13.8253 12.0963 13.3336 12.7147 12.7137C13.3346 12.0953 13.8263 11.3605 14.1614 10.5515C14.4965 9.74254 14.6684 8.87532 14.6673 7.99968C14.6684 7.12404 14.4965 6.25682 14.1614 5.44784C13.8263 4.63886 13.3346 3.90407 12.7147 3.28568C12.0963 2.66573 11.3615 2.17409 10.5525 1.83898C9.74351 1.50388 8.87629 1.33193 8.00066 1.33301C7.12502 1.33193 6.2578 1.50388 5.44882 1.83898C4.63984 2.17409 3.90505 2.66573 3.28666 3.28568C2.66671 3.90407 2.17506 4.63886 1.83996 5.44784C1.50486 6.25682 1.33291 7.12404 1.33399 7.99968C1.33291 8.87532 1.50486 9.74254 1.83996 10.5515C2.17506 11.3605 2.66671 12.0953 3.28666 12.7137C3.90505 13.3336 4.63984 13.8253 5.44882 14.1604C6.2578 14.4955 7.12502 14.6674 8.00066 14.6663Z"
                            fill="white"
                            stroke="white"
                            strokeWidth="1.33333"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M5.33398 8L7.33398 10L11.334 6"
                            stroke="black"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </mask>
                        <g mask="url(#mask0)">
                          <rect width="16" height="16" fill="#0088FF" />
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <p className="text-blue-500 text-sm">Certified</p>
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-row gap-10">
        {tabs.map((tab) => (
          <div
            key={tab}
            onClick={() => handleTabClick(tab)}
            className={`relative cursor-pointer font-medium pb-1 group ${
              selectedTab === tab ? "text-[#1D2739]" : "text-[#BABABA]"
            }`}
          >
            {tab}
            {selectedTab === tab && (
              <span className="absolute bottom-0 left-0 h-[2px] w-full bg-[#08F] rounded-[1px]"></span>
            )}
          </div>
        ))}
      </div>

      {isEngagementTab && (
        <div className="flex flex-row gap-10">
          {engagementTabs.map((tab) => (
            <div
              key={tab}
              onClick={() => handleEngagementTabClick(tab)}
              className={`relative cursor-pointer font-medium pb-1 group ${
                selectedEngagementTab === tab
                  ? "text-[#1D2739]"
                  : "text-[#BABABA]"
              }`}
            >
              {tab}
              {selectedEngagementTab === tab && (
                <span className="absolute bottom-0 left-0 h-[2px] w-full bg-[#08F] rounded-[1px]"></span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Tabs;
